/**
 * Metadata types that can be attached to decode results
 */
export enum ResultMetadataType {
  OTHER = 0,
  ORIENTATION = 1,
  BYTE_SEGMENTS = 2,
  ERROR_CORRECTION_LEVEL = 3,
  ISSUE_NUMBER = 4,
  SUGGESTED_PRICE = 5,
  POSSIBLE_COUNTRY = 6,
  UPC_EAN_EXTENSION = 7,
  PDF417_EXTRA_METADATA = 8,
  STRUCTURED_APPEND_SEQUENCE = 9,
  STRUCTURED_APPEND_PARITY = 10,
  SYMBOLOGY_IDENTIFIER = 11,
  QR_MASK_PATTERN = 12,
  QR_VERSION = 13,
  QR_ERRORS_CORRECTED = 14,
  QR_ERASURES = 15,
}
